<template>
    <div>
        <div 
            class="uploading-area position-relative" 
            v-b-tooltip.hover.left
            :title="`Max File Size ${maxSize}MB`">
            <div class="close-icon position-absolute" v-if="image">
                <Icon icon='cross' @click.native = "removeImage"/>
            </div>
            <div
                @dragover.prevent
                :id="`${type || 'image'}-dragover`"
                @drop.prevent="onImageUpload($event.dataTransfer.files[0])"
                class="drag-img-wrap d-flex justify-content-center align-items-center">
                <label v-if="!image" class="image-label m-0 w-100 h-100">
                    <div class="hint d-flex justify-content-center align-items-center h-100 flex-column" >
                        <slot name="content"></slot>
                    </div>
                    <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        @change="onImageUpload($event.target.files[0])"
                        class="d-none"/>
                </label>
                <img
                    class="uploaded-image"
                    :class="{logo: type === 'logo'}"
                    v-if="image"
                    :src = "image" />
                
            </div>
        </div>
        <p id="uploading-cover" v-if="uploadingInProcess" class="tlab mt-1 pl-1">
                Uploading...<br/>
                Please wait for upload to complete.
        </p>
        <div id="err-box" class="tlabb mt-2 ml-1 error-text text-center" v-else-if="uploadingError || missingImageError">
            {{uploadingError || missingImageError}}
        </div>
    </div>
</template>
<script>
import Icon from '../Theme/Icon'
import {validateUploading} from "../../core/_validateUploading";
import {ref, computed} from '@vue/composition-api'
import {uploadImage} from '../../firebaseCRUD'

export default {
    name: 'Step2',
    props: {
        type: String,
        defaultImage: String,
        maxSize: String,
        requiredError: String
    },
    components: {
        Icon
    },
    setup(props, {emit}){

        const image = ref(props.defaultImage || null)
        const uploadingError = ref(null)
        const uploadingInProcess = ref(false)

        const missingImageError = computed(() => props.requiredError)

        const onImageUpload = async file => {
            if(!file) {
                return;
            }

            uploadingError.value = validateUploading(file, props.maxSize, true);
            
            if(uploadingError.value) {
                return
            }

            try {
                uploadingInProcess.value = true

                image.value = await uploadImage(file)

                emit('setImage', {
                    type: props.type, 
                    url: image.value
                })
               
            } catch(e){
                console.log(e)
            } finally {
                uploadingInProcess.value = false
            }
        }

        const removeImage = () => {
            image.value = null
             emit('setImage', {
                type: props.type, 
                url: null
            })
            uploadingError.value = false
        }

        return {
            image,
            uploadingInProcess,
            onImageUpload,
            removeImage,
            uploadingError,
            missingImageError
        }
    }
}
</script>

<style lang="scss" scoped>
    .uploading-area {
        border: 10px solid #f4f7fa;
        border-radius: 8px;
    }
    #shop-description-field {
        border: 1px solid #CBD5E0;
        border-radius: 4px;
        padding: 12px 16px;
        resize: initial!important;
        min-height: 164px;
    }

    .drag-img-wrap {
        width: 100%;
        background-repeat: no-repeat;
        border-radius: 8px;
        background-size: 100% 100%;
    }


    #logo-dragover {
        height: 72px;
        background-image: url('/img/upload֊shop-logo.png')
    }

    #image-dragover {
        height: 176px;
        background-image: url('/img/upload-shop-image.png')
    }

    .image-label {
        cursor: pointer;
        border-radius: 8px;
    }

    .uploaded-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 8px;
        background: #fff;

        &.logo {
            width: 56px;
            height: 56px;
            border-radius: 50%;
        }
    } 


    .close-icon {
        top: -5px;
        right: -5px;
        cursor: pointer;
    }
</style>